import { FC } from 'react';

import { Feedback } from '../../lib';
import { FeedbackContent } from '../feedback-card/feedback-content';
import { FeedbackSkeleton } from '../feedback-card/feedback-skelton';
import { EmptyState } from './empty-state';

interface ViewFeedbackContentProps {
	error: unknown;
	evaluation?: Feedback;
	isLoading: boolean;
}

export const ViewFeedbackContent: FC<ViewFeedbackContentProps> = ({ error, evaluation, isLoading }) => {
	if (isLoading) {
		return <FeedbackSkeleton />;
	}

	if (error || !evaluation) {
		return <EmptyState />;
	}

	return <FeedbackContent evaluation={evaluation} variant="responseModal" />;
};
